export default __webpack_public_path__ + "static/media/hair.1aa63794.svg";